import { Modal, Progress } from 'antd';
export default function Loading({ open, process }) {
    return (
        <>
            <Modal
                width={740}
                className="_modal"
                footer={false}
                open={open}
                closable={false}
                centered
            >
                <div className="grid grid-cols-1">
                    <div>
                        <Progress
                            strokeColor={{
                                '0%': '#E6E6FA',
                                '100%': '#7D7AFF',
                            }}
                            percent={process}
                            strokeWidth={20}
                            status="active"
                        />
                    </div>
                    <div>
                        <div className="text-center text-base font-semibold">
                            Migrating data to a new source...
                        </div>
                    </div>
                </div>
            </Modal>
        </>
    );
}
